// extracted by mini-css-extract-plugin
export default {"phaseColorPicker":"PhaseColorPicker-module__phaseColorPicker___VDuqc","iconBox":"PhaseColorPicker-module__iconBox___LtEcQ","active":"PhaseColorPicker-module__active___SZ0Q2"};